import { defineMessages } from "react-intl";
import { CHARGE_ALERTS } from "../witadmin/Common/constants";

export const automaticChargesMessages = defineMessages({
  entityName: {
    id: "automaticCharges.title.default",
    defaultMessage: "Listado de cobros automáticos",
  },
  bookingId: {
    id: "automaticCharges.bookingId",
    defaultMessage: "Reservation ID",
  },
  multipleBookingId: {
    id: "automaticCharges.multipleBookingId",
    defaultMessage: "Multiple ID",
  },
  status: {
    id: "automaticCharges.status",
    defaultMessage: "Res. Status",
  },
  cancellationPolicy: {
    id: "automaticCharges.cancellationPolicy",
    defaultMessage: "Concept",
  },
  paymentType: {
    id: "automaticCharges.paymentType",
    defaultMessage: "Payment type",
  },
  estimatedCollectDate: {
    id: "automaticCharges.estimatedCollectDate",
    defaultMessage: "Estimated collect date",
  },
  effectiveCollectDate: {
    id: "automaticCharges.effectiveCollectDate",
    defaultMessage: "Estimated collect date",
  },
  chargeStatus: {
    id: "automaticCharges.chargeStatus",
    defaultMessage: "Charge Status",
  },
  intents: {
    id: "automaticCharges.intents",
    defaultMessage: "Intents",
  },
  amount: {
    id: "automaticCharges.amount",
    defaultMessage: "Amount",
  },
  currency: {
    id: "automaticCharges.currency",
    defaultMessage: "Currency",
  },
  goToReservation: {
    id: "automaticCharges.actions.goToReservation",
    defaultMessage: "Ir a la reserva",
  },
  modifiedReservation: {
    id: "automaticCharges.actions.modifiedReservation",
    defaultMessage: "Reserva modificada - gestionar desde la reserva",
  },
  failedPayment: {
    id: "automaticCharges.actions.failedPayment",
    defaultMessage: "Fallo en el cobro",
  },
  cannotBeCharged: {
    id: "automaticCharges.actions.cannotBeCharged",
    defaultMessage: "No se puede cobrar",
  },
  retryCharge: {
    id: "automaticCharges.actions.retryCharge",
    defaultMessage: "Reintentar cobro",
  },
  cancelCharge: {
    id: "automaticCharges.actions.cancelCharge",
    defaultMessage: "Cancelar cobro",
  },
  cancelChargeError: {
    id: "automaticCharges.actions.cancelChargeError",
    defaultMessage: "No se pudo procesar la cancelación de este cobro",
  },
  cancelChargeSuccess: {
    id: "automaticCharges.actions.cancelChargeSuccess",
    defaultMessage: "Cobro cancelado correctamente",
  },
  retryChargeError: {
    id: "automaticCharges.actions.retryChargeError",
    defaultMessage: "No se pudo procesar el cobro",
  },
  retryChargeSuccess: {
    id: "automaticCharges.actions.retryChargeSuccess",
    defaultMessage: "Cobro procesado correctamente",
  },
  back: {
    id: "automaticCharges.actions.back",
    defaultMessage: "Volver",
  },
  jobLastExecution: {
    id: "automaticCharges.jobLastExecution",
    defaultMessage: "f.estimada de cobro",
  },
  retryChargeTimeValidation: {
    id: "automaticCharges.actions.retryChargeTimeValidation",
    defaultMessage: "No se puede realizar la acción. Volver a intentar dentro de 5 minutos.",
  },
  retryChargeMultipleBookingConfirmation: {
    id: "automaticCharges.actions.retryChargeMultipleBookingConfirmation",
    defaultMessage:
      "Se van a ejecutar todas las órdenes de cobro que se puedan agrupar y que están vinculadas a esa misma {multipleBookingId}.",
  },
  cancel: {
    id: "automaticCharges.actions.cancel",
    defaultMessage: "Cancelar",
  },
});

export const automaticChargesFilterMessages = defineMessages({
  bookingId: {
    id: "automaticCharges.filter.bookingId",
    defaultMessage: "Reservation Id",
  },
  multipleBookingId: {
    id: "automaticCharges.filter.multipleBookingId",
    defaultMessage: "Multiple Booking Id",
  },
  status: {
    id: "automaticCharges.filter.status",
    defaultMessage: "Res. Status",
  },
  chargeStatus: {
    id: "automaticCharges.filter.chargeStatus",
    defaultMessage: "Charge Status",
  },
  paymentType: {
    id: "automaticCharges.filter.paymentType",
    defaultMessage: "Payment Type",
  },
  cancellationPolicy: {
    id: "automaticCharges.filter.cancellationPolicy",
    defaultMessage: "Concept",
  },
  amount: {
    id: "automaticCharges.filter.amount",
    defaultMessage: "Importe",
  },
  effectiveCollectDate: {
    id: "automaticCharges.effectiveCollectDate",
    defaultMessage: "f.cobro",
  },
  alerts: {
    id: "automaticCharges.filter.alerts",
    defaultMessage: "Avisos",
  },
  [CHARGE_ALERTS.CANNOT_CHARGED]: {
    id: "automaticCharges.filter.KO",
    defaultMessage: "No se puede cobrar",
  },
  [CHARGE_ALERTS.MODIFIED_BY_RESERVATION]: {
    id: "automaticCharges.filter.MODIFIED_BY_ROOM_STAY",
    defaultMessage: "Reserva modificada",
  },
  [CHARGE_ALERTS.CHARGE_FAILED]: {
    id: "automaticCharges.filter.EXPIRED",
    defaultMessage: "Cobro fallido",
  },
});
